<template>
  <div class="result-header">
    <a class="result-header__back" href="/payment/library" v-show="backButton">
      <span>戻る</span>
    </a>
    <span class="result-header__title">購入履歴</span>
  </div>
</template>

<script>
export default {
  name: "result-header",
  props: {
    backButton: {
      type: Boolean,
      default: false,
    }
  },

}
</script>

<style lang="scss">
.result-header {
  max-width: 580px;
  margin: 0 auto;
  text-align: center;
  position: relative;
  font-family: "Hiragino Kaku Gothic Pro";

  &__back {
    position: absolute;
    left: 15px;
    text-decoration: none;

    span {
      line-height: 12px;
      font-size: 12px;
      color: #000000;
      display: inline-block;
      padding: 17px 0;
      margin-left: 7px;
    }

    &:before {
      content: "";
      width: 8px;
      height: 14px;
      background-image: url("/static/img/common/arrow_left_black.svg");
      background-size: contain;
      background-repeat: no-repeat;
      display: inline-block;
      position: relative;
      top: 3px;
    }
  }

  &__title {
    padding: 16px 0;
    display: inline-block;
    line-height: 14px;
    font-size: 14px;
    color: #000000;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/ResultHeader.vue